import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { Observable, of, Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import { map, tap, startWith } from 'rxjs/operators';
import { PrestamoAbonoService } from 'src/app/services/prestamo-abono/prestamo-abono.service'
import { PrestamosService } from 'src/app/services/prestamos/prestamos.service';
import { AfiliacionService } from 'src/app/services/afiliacion/afiliacion.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';



export interface DialogData {

  id: any
  idCuota: any  
  motivoAnulacion: any
  email: any
  recarga: boolean
  nombreCompleto: any
  nombreProducto: any
  comentarioRechazo: any
}

@Component({
  selector: 'dialog-overview-example-dialog',
  templateUrl:'../../pages/afiliacion/pago-cuota/pago-cuota-anular.html',
  styleUrls: ['../../pages/afiliacion/pago-cuota/pago-cuota.component.css']
})

export class DialogAnularReversarCuota {
  prestamos: any
  planes: any
  config: any = { itemsPerPage: 5, currentPage: 1, totalItems: 5, indexInicial: 0, indexMaximo: 5 }
  configPlan: any = { itemsPerPage: 10, currentPage: 1, totalItems: 10, indexInicial: 0, indexMaximo: 10 }
  buscador: any =
    {
      selectPrestamo: 0,
      rut: '', rut2: '', rutAfiliado: '', region: '', fechaInicio: '', fechaFin: '', itemsPerPage: 5, currentPage: 1, idSolicitud: '',
      estado: ['PAGADA']
    }


  constructor(public router: Router, public dialogRef: MatDialogRef<DialogAnularReversarCuota>, public prestamoAbonoService: PrestamoAbonoService,
    private afiliacionService: AfiliacionService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog) {
    this.data.recarga = false

  }

  onAnularReversar() {
    let idCuota = this.data.idCuota
    let motivoAnulacion = this.data.motivoAnulacion
    let vm = this;
    if(this.data.motivoAnulacion == '')
    {   
        this.openAlertDialog('Debe ingresar el motivo de anulación.', 'btn-danger')
        return false
    }

    
    this.afiliacionService.anularReversarCuota(idCuota,
      motivoAnulacion, localStorage.getItem("idUsuario")).then(
        () => {
          vm.data.recarga = true
          Swal.close()
          vm.dialogRef.close()
          this.openAlertDialog('La cuota se ha anulado/reversado exitosamente.', 'btn-success')
        }
      )
      .catch
      (
        error => {
          Swal.close();
          console.log(error)
          vm.dialogRef.close()
          vm.openAlertDialog('La cuota no se ha podido anular/reversar.', 'btn-danger')
        }
      )
  }


 

  buscarListaPrestamos(idUsuario: any) {
  
    let vm = this
    this.prestamoAbonoService.traePrestamosPagados(idUsuario, this.buscador).then(
      (prestamosPagados: any) => {
        vm.prestamos = prestamosPagados.resultado
        vm.buscador.paginasTotal = prestamosPagados.resultado.length
        vm.config.currentPage = this.buscador.currentPage
        vm.config.totalItems = prestamosPagados.cantidadRegistros
        this.data.recarga = true
        Swal.close();
      }

    ).catch(error => console.log(error))
    // this.reloadComponent();
  }


  onCancelarClick(): void {
    this.data.recarga = false
    this.dialogRef.close()
  }

  openAlertDialog(mensaje: string, clase: string) {
    this.dialog.open(AlertDialogComponent, {
      data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
    })
  }

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }


}
